import { ThemeProvider } from '@mui/system';
import { DataContext } from '@context/DataContext';
import InvestigationProvider from './Context/InvestigationContext';
import LoadingComponent from './Components/Loading';
import { BrowserRouter } from 'react-router-dom';
import AppRoutes from './Routes/AppRoutes';
import { LocalizationProvider } from '@context/LocalizationContext';
import { getThemeFromConfig } from './Theming/applicationTheme';
import { LoadingProvider } from '@context/LoadingContext';
import { ErrorBoundary } from './Config/bugsnag';

const queryParams = new URLSearchParams(window.location.search);

function App() {
	const applicationTheme: any = getThemeFromConfig();
	return (
		<ErrorBoundary>
			<ThemeProvider theme={applicationTheme}>
				<LocalizationProvider>
					<div
						id={'myApp'}
						style={{ backgroundColor: applicationTheme.palette.appBackground }}
						className="App">
						<header className="App-header">
							<BrowserRouter>
								<DataContext.Provider
									value={{
										sc: queryParams.get('sc') ?? '',
									}}>
									<InvestigationProvider>
										<LoadingProvider>
											<>
												<LoadingComponent />
												<AppRoutes />
											</>
										</LoadingProvider>
									</InvestigationProvider>
								</DataContext.Provider>
							</BrowserRouter>
						</header>
					</div>
				</LocalizationProvider>
			</ThemeProvider>
		</ErrorBoundary>
	);
}

export default App;
